import { useState, useEffect } from 'react';
var useCountdownTimer = function (props) {
    var _a = useState(props.milliseconds), timeLeft = _a[0], setTimeLeft = _a[1];
    useEffect(function () {
        setTimeLeft(props.milliseconds);
    }, [props.milliseconds]);
    useEffect(function () {
        if (timeLeft <= 0)
            return;
        var timer = setTimeout(function () {
            setTimeLeft(timeLeft - 1000);
        }, 1000);
        return function () { return clearTimeout(timer); };
    }, [timeLeft]);
    return timeLeft;
};
export default useCountdownTimer;
